/**
 * Asynchronously loads the component for HomePage
 */
import Loadable from 'ui/Loadable';

export default Loadable({
  loader: () => import(/* webpackChunkName: "summary-page" */ './index'),
});
